import { useEffect, useRef } from "react";

declare global {
  interface Window {
    grecaptcha: any;
    ReactNativeWebView: any;
  }
}

export const Captcha = ({
  onVerify,
}: {
  onVerify?: (token: string) => void;
}) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const renderRecaptcha = () => {
      if (window.grecaptcha && containerRef.current) {
        window.grecaptcha.render("recaptchaContainer", {
          sitekey: "6LfpxCorAAAAAPWi-vn80zIovB_IUnj6wKmOLOjT",
          callback: (token: string) => {
            console.log("Verified token:", token);
            window.ReactNativeWebView?.postMessage(JSON.stringify({ token }));
            if (onVerify) {
              onVerify(token);
            }
          },
        });

        // Observe height changes in the CAPTCHA widget
        // Wait for iframe to load
        // const checkIframeLoaded = setInterval(() => {
        //   const container = document.getElementById("rc-imageselect");
        //   let height = 78;
        //   if (container) {
        //     //clearInterval(checkIframeLoaded);
        //     height = container.offsetHeight;
        //   }
        //   window.ReactNativeWebView?.postMessage(
        //     JSON.stringify({
        //       height,
        //     })
        //   );
        // }, 1000);
      }
    };

    // If grecaptcha is not ready immediately
    if (!window.grecaptcha || !window.grecaptcha.render) {
      const interval = setInterval(() => {
        if (window.grecaptcha && window.grecaptcha.render) {
          clearInterval(interval);
          renderRecaptcha();
        }
      }, 200);
    } else {
      renderRecaptcha();
    }
  }, []);

  return (
    <div>
      <div id="recaptchaContainer" ref={containerRef} />
    </div>
  );
};
